export default {
  login(redirectUrl) {
    redirectUrl = redirectUrl || location.href
    window.location.href = `${process.env.HUYA_APP_H5}/login.html?redirect=${encodeURIComponent(redirectUrl)}`
  },

  logout(redirectUrl) {
    redirectUrl = redirectUrl || location.href
    window.location.href = `${process.env.HUYA_APP_H5}/logout.html?redirect=${encodeURIComponent(redirectUrl)}`
  }
}